/**
 * Auma.Web.Services.ReleaseInfo.ManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { NotesOverviewResponseModel } from '../model/notesOverviewResponseModel';
import { ProblemDetails } from '../model/problemDetails';
import { VersionArtefactOverviewResponseModel } from '../model/versionArtefactOverviewResponseModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ArtefactManagementService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param versionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiArtefactManagementDownloadVersionArtifactVersionIdGet(versionId: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public apiArtefactManagementDownloadVersionArtifactVersionIdGet(versionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public apiArtefactManagementDownloadVersionArtifactVersionIdGet(versionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public apiArtefactManagementDownloadVersionArtifactVersionIdGet(versionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (versionId === null || versionId === undefined) {
            throw new Error('Required parameter versionId was null or undefined when calling apiArtefactManagementDownloadVersionArtifactVersionIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/api/ArtefactManagement/DownloadVersionArtifact/${encodeURIComponent(String(versionId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param versionId 
     * @param langCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiArtefactManagementGetNotesOverviewGet(versionId?: number, langCode?: string, observe?: 'body', reportProgress?: boolean): Observable<NotesOverviewResponseModel>;
    public apiArtefactManagementGetNotesOverviewGet(versionId?: number, langCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotesOverviewResponseModel>>;
    public apiArtefactManagementGetNotesOverviewGet(versionId?: number, langCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotesOverviewResponseModel>>;
    public apiArtefactManagementGetNotesOverviewGet(versionId?: number, langCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (versionId !== undefined && versionId !== null) {
            queryParameters = queryParameters.set('versionId', <any>versionId);
        }
        if (langCode !== undefined && langCode !== null) {
            queryParameters = queryParameters.set('langCode', <any>langCode);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NotesOverviewResponseModel>('get',`${this.basePath}/api/ArtefactManagement/GetNotesOverview`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param productClientTag 
     * @param languageCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiArtefactManagementGetVersionOverviewGet(productClientTag?: string, languageCode?: string, observe?: 'body', reportProgress?: boolean): Observable<VersionArtefactOverviewResponseModel>;
    public apiArtefactManagementGetVersionOverviewGet(productClientTag?: string, languageCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VersionArtefactOverviewResponseModel>>;
    public apiArtefactManagementGetVersionOverviewGet(productClientTag?: string, languageCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VersionArtefactOverviewResponseModel>>;
    public apiArtefactManagementGetVersionOverviewGet(productClientTag?: string, languageCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (productClientTag !== undefined && productClientTag !== null) {
            queryParameters = queryParameters.set('productClientTag', <any>productClientTag);
        }
        if (languageCode !== undefined && languageCode !== null) {
            queryParameters = queryParameters.set('languageCode', <any>languageCode);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VersionArtefactOverviewResponseModel>('get',`${this.basePath}/api/ArtefactManagement/GetVersionOverview`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param versionId 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiArtefactManagementUploadArtefactVersionIdPostForm(versionId: number, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiArtefactManagementUploadArtefactVersionIdPostForm(versionId: number, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiArtefactManagementUploadArtefactVersionIdPostForm(versionId: number, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiArtefactManagementUploadArtefactVersionIdPostForm(versionId: number, file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (versionId === null || versionId === undefined) {
            throw new Error('Required parameter versionId was null or undefined when calling apiArtefactManagementUploadArtefactVersionIdPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/ArtefactManagement/UploadArtefact/${encodeURIComponent(String(versionId))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param versionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteArtefact(versionId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteArtefact(versionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteArtefact(versionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteArtefact(versionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (versionId === null || versionId === undefined) {
            throw new Error('Required parameter versionId was null or undefined when calling deleteArtefact.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ArtefactManagement/Versions/${encodeURIComponent(String(versionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
